var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 840,
    height: 608,
    viewBox: "0 0 840 608",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M668.376 217.466L833.385 121.736L720.064 58.668L563.477 150.928",
    stroke: "white",
    strokeWidth: 5.80476,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M563.47 150.928L560.969 152.399",
    stroke: "white",
    strokeWidth: 5.80476,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M556.092 155.27L470.773 205.539",
    stroke: "white",
    strokeWidth: 5.80476,
    strokeMiterlimit: 10,
    strokeDasharray: "8.81 8.81"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M468.334 206.977L465.832 208.448L468.342 209.901",
    stroke: "white",
    strokeWidth: 5.80476,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M473.309 212.763L570.21 268.635",
    stroke: "white",
    strokeWidth: 5.80476,
    strokeMiterlimit: 10,
    strokeDasharray: "8.81 8.81"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M572.699 270.062L575.21 271.515L577.72 270.062",
    stroke: "white",
    strokeWidth: 5.80476,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M582.902 267.049L663.262 220.426",
    stroke: "white",
    strokeWidth: 5.80476,
    strokeMiterlimit: 10,
    strokeDasharray: "8.81 8.81"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M665.859 218.92L668.37 217.467",
    stroke: "white",
    strokeWidth: 5.80476,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M465.832 541.51L575.206 604.57L833.382 454.791L720.061 391.731L465.832 541.51Z",
    stroke: "#231F20",
    strokeWidth: 2.89797,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M466.457 541.51L575.831 604.57L833.998 454.791L720.686 391.731L466.457 541.51Z",
    stroke: "white",
    strokeWidth: 5.80476,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M575.211 436.858V604.571",
    stroke: "white",
    strokeWidth: 5.80476,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M719.078 58.668V391.732",
    stroke: "white",
    strokeWidth: 5.80476,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M833.27 121.63V454.686",
    stroke: "white",
    strokeWidth: 5.80476,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M465.832 378.317V540.41",
    stroke: "white",
    strokeWidth: 5.80476,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M465.832 207.354V378.317",
    stroke: "white",
    strokeWidth: 5.80476,
    strokeMiterlimit: 10,
    strokeDasharray: "8.81 8.81"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M181.991 242.571C209.254 242.571 231.354 220.47 231.354 193.208C231.354 165.946 209.254 143.846 181.991 143.846C154.729 143.846 132.629 165.946 132.629 193.208C132.629 220.47 154.729 242.571 181.991 242.571Z",
    fill: "#F8EB30"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M541.889 437.634L563.469 450.062L563.425 508.929L541.457 495.822L541.889 437.634Z",
    stroke: "white",
    strokeWidth: 1.45339,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M511.342 419.401L532.922 431.83L532.878 490.706L510.91 477.599L511.342 419.401Z",
    stroke: "white",
    strokeWidth: 1.45339,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M482.068 401.21L503.649 413.639L503.605 472.514L481.637 459.407L482.068 401.21Z",
    stroke: "white",
    strokeWidth: 1.45339,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M541.889 508.929L563.469 521.366L563.425 580.233L541.457 567.126L541.889 508.929Z",
    stroke: "white",
    strokeWidth: 1.45339,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M511.342 490.704L532.922 503.133L532.878 562L510.91 548.893L511.342 490.704Z",
    stroke: "white",
    strokeWidth: 1.45339,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M482.068 472.515L503.649 484.943L503.605 543.81L481.637 530.703L482.068 472.515Z",
    stroke: "white",
    strokeWidth: 1.45339,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M619.741 412.926L576.482 437.872L474.375 378.635L519.192 353.689L619.741 412.926Z",
    fill: "#F8EB30"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M661.878 329.757L618.611 354.703L516.504 295.457L561.321 270.521L661.878 329.757Z",
    fill: "#F8EB30"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1 90.846C6.91046 90.846 535.337 385.409 535.337 385.409L803.105 1",
    stroke: "#F8EB30",
    strokeWidth: 2.89797,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M575.207 437.872V604.572",
    stroke: "white",
    strokeWidth: 5.80476,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M575.207 271.516V437.872",
    stroke: "white",
    strokeWidth: 5.80476,
    strokeMiterlimit: 10,
    strokeDasharray: "8.81 8.81"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.8e9ccb8d165223a3a434dad2da67908e.svg";
export { ForwardRef as ReactComponent };